import { render, staticRenderFns } from "./AdminMenuHonors.vue?vue&type=template&id=27083f70&"
import script from "./AdminMenuHonors.vue?vue&type=script&lang=js&"
export * from "./AdminMenuHonors.vue?vue&type=script&lang=js&"
import style0 from "./AdminMenuHonors.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AdminMenuHonors.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports